module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-product-item"
  }, [_c('div', {
    staticClass: "__left"
  }, [(_vm.showPicture) ? _c('div', {
    staticClass: "picture-exist"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgSrc || _vm.defaultPicture
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "__right"
  }, [_vm._t("title", function() {
    return [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n        ")])]
  }), _vm._v(" "), _vm._t("sub-title", function() {
    return [_c('div', {
      staticClass: "sub-title"
    }, [_vm._v("\n        " + _vm._s(_vm.subTitle) + "\n        ")])]
  }), _vm._v(" "), _vm._t("default", function() {
    return [_c('div', {
      staticClass: "tag"
    }, _vm._l((_vm.tagList), function(tag, index) {
      return _c('rt-tag', {
        key: index,
        attrs: {
          "color-type": tag.colorType || 'warning'
        }
      }, [_vm._v("\n          " + _vm._s(tag.text) + "\n        ")])
    }), 1)]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62415b3c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/product/rtProductItem.vue
// module id = 2161
// module chunks = 137